import Logo2 from "../../assets/navbar/logo.svg";
import React, { useState, useEffect, useRef } from "react";
import "../homepage/homepage.css";
import { useNavigate } from "react-router";
import "./auth.css";

import SubmitIcon from "../../assets/contactus/submit.svg";
import { ClipLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import { ApiHelper } from "../../utilFunctions/utilfunction";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

export const Login = () => {
    const params = useParams();
    const [banner, setBanner] = useState();
    const [loading, setLoading] = useState(false);
    const [flashmessage, setFlashmessage] = useState(false);
    const [isError, setIsError] = useState(false);
    const [messagess, setMessagess] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        trigger,
    } = useForm();

    const Submit = async (event) => {
        setLoading(true);
        setFlashmessage(false);
        setMessagess("");

        const { email, password } = event;
        const reqToSend = { email, password };

        try {
            const url = "/login";
            const response = await ApiHelper(url, reqToSend, "POST");

            if (response?.code === 200 && response?.status === true && response?.data?.user_id) {
                const userId = response?.data?.user_id;

                setIsError(false);
                setMessagess(response?.message || "Login successful.");
                setFlashmessage(true);
                setTimeout(() => {
                    navigate('/two-factor-authentication')
                }, 2000);
               

                    if (userId) {
                        const now = Date.now();
                        const expiry = now + 24 * 60 * 60 * 1000; // 24 hours
                        // const expiry = now + 5 * 60 * 1000;
                        localStorage.setItem("user_id", JSON.stringify({ value: userId, expiry }));
                    }

            } else {
                const errorMsg = response?.message || "Login failed.";
                setIsError(true);
                setMessagess(errorMsg);
                setFlashmessage(true);
                setTimeout(() => {
                    setFlashmessage(false);
                    setMessagess("");
                    setIsError(false);
                }, 10000);
            }
        } catch (error) {
            const fallbackMsg = "Something went wrong. Please try again.";
            setIsError(true);
            setMessagess(fallbackMsg);
            setFlashmessage(true);
            toast.error(fallbackMsg);
        } finally {
            setLoading(false);
            setTimeout(() => {
                setFlashmessage(false);
                setMessagess("");

                setIsError(false);
            }, 5000);
        }
    };

    const navigate = useNavigate();
    useEffect(async () => {
        let url = "/banner";
        let bannerdata = await ApiHelper(url);
        setBanner(bannerdata);
    }, []);

    {
        loading && (
            <div className="loader-wrapper">
                <ClipLoader color="#36d7b7" size={40} />
            </div>
        );
    }
    return (
        <>
            <section className="mainhomepage ">
                <div className="wholepopup d-flex justify-content-center align-items-center w-100">
                    <div className="container d-flex flex-column back_image_color flex-md-row align-items-center ps-lg-0 pe-lg-0 mb-5" >
                        {banner && banner.data.length ? (
                            <div className="col-12 col-md-6">
                                {banner.data.map((value, index) => (
                                    <img
                                        key={index}
                                        className="for_height mw-100 w-100"
                                        src={value ? value.image_path : ""}
                                        alt="image"
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="col-12 col-md-6"></div>
                        )}

                        <div className="col-12 col-md-6">
                            <div
                                className="rightside_content d-flex justify-content-center align-items-center position-relative "

                            >
                                <div className="d-flex flex-column responsive-contianer flex-grow-1 align-items-center">
                                    <img className="logo2_bottom" src={Logo2} alt="logo" style={{ marginTop: '20px' }} />
                                    <h2
                                        className="mb-4 text-center fw-bold responsive-heading"
                                    >
                                        Login
                                    </h2>
                                    <form className="form w-100" onSubmit={handleSubmit(Submit)}>
                                        <div className="d-flex flex-column  login-form w-100">
                                            <div className="textOnInput ">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    {...register("email", {
                                                        required: "Email is required",
                                                    })}
                                                />

                                                {errors.email && (
                                                    <div style={{ minHeight: "18px" }}>
                                                        <p className="text-danger small mb-0">
                                                            {errors.email.message}
                                                        </p>
                                                    </div>
                                                )}

                                                <label htmlFor="email">Email*</label>
                                            </div>
                                            <div
                                                className="textOnInput"
                                                style={{ position: "relative" }}
                                            >
                                                <input
                                                    className="form-control"
                                                    type={showPassword ? "text" : "password"}
                                                    {...register("password", {
                                                        required: "Password is required",
                                                    })}
                                                />
                                                <div
                                                    className="d-flex justify-content-between align-items-center mt-1"
                                                    style={{ minHeight: "20px" }}
                                                >
                                                    <div>
                                                        {errors.password && (
                                                            <p className="text-danger small mb-0">
                                                                {errors.password.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                    <a
                                                        href="/forgot-password"
                                                        className="forgot-password-link text-end"
                                                    >
                                                        Forgot Password?
                                                    </a>
                                                </div>

                                                <label htmlFor="password">Password*</label>

                                                <span
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{
                                                        position: "absolute",
                                                        right: "12px",
                                                        top: errors?.password ? "27%" : "34%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        fontSize: "1.2rem",
                                                        color: "#888",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        height: "100%",
                                                    }}
                                                >
                                                    {showPassword ? (
                                                        <EyeOff size={18} />
                                                    ) : (
                                                        <Eye size={18} />
                                                    )}
                                                </span>
                                            </div>

                                            {flashmessage && messagess && (
                                                <div
                                                    className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${isError ? "text-danger" : "text-black"
                                                        }`}
                                                    style={{ marginBlock: '5px' }}
                                                >
                                                    {!isError && (
                                                        <img className=" pe-2" src={SubmitIcon} alt="" />
                                                    )}
                                                    <span className="fs-5">
                                                        {messagess}
                                                    </span>
                                                </div>
                                            )}

                                            <div>
                                                <button
                                                    type="submit"
                                                    className="auth-button w-100"
                                                    style={{
                                                        fontSize: "18px",
                                                        fontWeight: "bold",
                                                        fontFamily: "Times New Roman",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                    disabled={loading} // optionally disable while loading
                                                >
                                                    {loading ? (
                                                        <div
                                                            className="spinner-border text-light"
                                                            style={{
                                                                width: "1.5rem",
                                                                height: "1.5rem",
                                                                borderWidth: "0.2em",
                                                                borderColor: "#ccc", // All borders
                                                                borderTopColor: "#333", // Spinner color
                                                            }}
                                                            role="status"
                                                        >
                                                            <span className="visually-hidden">
                                                                Loading...
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        "Login"
                                                    )}
                                                </button>

                                                <div className="d-flex justify-content-center mt-2">
                                                    <span className="medium text-black">
                                                        Create a new account?
                                                    </span>
                                                    <a
                                                        href="/register"
                                                        className="medium text-decoration-none ms-1"
                                                    >
                                                        Sign Up
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
